<template>
  <div class="container float-container no-margin">
    <label :for="'email-' + _uid" :class="{ error: error }">{{ label }}</label>
    <select
      @click="$emit('click')"
      :value="value"
      @input="$emit('input', $event.target.value)"
      :style="{
        background:
          'url(\'' + imagen + '\') no-repeat right 16px top' + backgroundColor
      }"
    >
      <select-option
        v-for="item in items"
        :label="item.label"
        :value="item.value"
        v-bind:key="item.value"
        :selected="item.value === value"
      />
    </select>
  </div>
</template>

<script>
import SelectOption from "@/components/core/custom/SelectOption";
export default {
  name: "CustomSelect",
  components: { SelectOption },
  props: {
    value: String,
    label: String,
    items: Array
  },
  data() {
    return {
      imagen: require("@/assets/img/1x/arrow-simple-down.svg"),
      backgroundColor: "#f4f4f4"
    };
  }
};
</script>

<style scoped>
div.float-container {
  position: relative;
}

label {
  font-size: 15px;
  color: #666;
  font-family: "BentonSansBBVA-Book", Helvetica, Arial, sans-serif;
  position: absolute;
  -webkit-transform-origin: top left;
  transform-origin: top left;
  transition: all 0.3s ease-in-out;
}

div.float-container label {
  /*
    Los selects tienen siempre el label en modo activo
    dado que siempre tienn un valor seleccionado por defecto
  */
  -webkit-transform: translate(16px, 8px) scale(0.75);
  transform: translate(16px, 8px) scale(0.75);
}

/* Estilos para errores */

label.error {
  color: #b92a45;
}

select {
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-left: 16px;
  /* Dar un poco de espacio para "centrar" el texto verticalmente */
  border-top: 17px solid transparent;
}
</style>
